import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate
import { BsArrowRightShort } from 'react-icons/bs';
import './Services.css';
import serviceHero from '../../assets/Services/hero.png';
import ctaImg from "../../assets/FullAbt/cta.png";
import CustomButton from '../Button/CustomButton';

const zoomVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "backOut" },
  },
};

const servicesData = [
  {
    id: "01",
    title: "Financial & Transaction Advisory",
    desc: "We help structure renewable energy projects in a way that works for banks, investors, and developers. Our support covers project finance, capital structuring, refinancing, and M&A advisory to make projects investment-ready.",
    path: "/services/finance" // Path matching App.js
  },
  {
    id: "02",
    title: "Project Development & Technical Due Diligence",
    desc: "We review project designs, energy generation estimates, and site conditions to reduce technical risks. Our team supports feasibility studies, owner's engineering, and due diligence for solar, wind, and BESS projects.",
    path: "/services/project-development" // Path matching App.js
  },
  {
    id: "03",
    title: "EPC Coordination & Execution Oversight",
    desc: "We support developers during execution by coordinating with EPC contractors and monitoring project progress. This includes planning support, construction oversight, and assistance through commissioning and handover.",
    path: "/services/epc-coordination" // Path matching App.js
  },
  {
    id: "04",
    title: "Emerging Energy & Strategic Advisory",
    desc: "We advise on new and growing clean energy areas such as BESS, hybrid projects, and green hydrogen. Our support helps clients plan future-ready projects and understand new technologies and policy directions.",
    path: "/services/emerging" // Path matching App.js
  }
];

const FullServices = () => {
  const navigate = useNavigate(); // 2. Initialize navigate

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0); // Ensures new page starts at the top
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: "easeOut" } 
    }
  };

  return (
    <section className="full-services-page">
      {/* Top Banner Section */}
      <div className="services-hero-banner mt-3" style={{ backgroundImage: `url(${serviceHero})` }}>
        <div className="overlay-dark"></div>
        <motion.div 
          className="container hero-content mt-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>Our Services</h1>
          <p>We support renewable energy projects, from planning to execution, with practical technical, financial, and on-ground advisory.</p>
        </motion.div>
      </div>

      {/* Main Services Grid */}
      <div className="services-main-content">
        <div className="container">
          <motion.div 
            className="services-cards-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
          >
            {servicesData.map((service, index) => (
              <motion.div 
                key={index} 
                className="service-big-card" 
                variants={cardVariants}
                onClick={() => handleNavigation(service.path)} // 3. Card click navigation
                style={{ cursor: 'pointer' }}
              >
                <div className="card-top">
                  <span className="service-number">{service.id}</span>
                  <div className="arrow-circle1">
                    <BsArrowRightShort />
                  </div>
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <div className="service-white-box">
                  <p>{service.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      <div style={{padding:"10px 50px", backgroundColor:"#F3F7F5"}}>
        <motion.div
          className="final-cta-card"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={zoomVariants}
        >
          <div className="cta-content">
            <h2>
              Let’s Build Your <br /> Renewable Energy <br /> Project
            </h2>
            <CustomButton
              variant="white"
              size="md"
              text="Discuss Your Project"
              onClick={() => handleNavigation("/contact")} // 4. CTA button navigation
            />
          </div>
          <div className="cta-image-box">
            <img src={ctaImg} alt="Construction Site" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FullServices;